import ErrorPage from 'pages/_error'
import { Component } from 'react'
import getBugsnagClient from 'shared/lib/getBugsnagClient'

function withBugsnagClient(App) {
  return class extends Component {
    render() {
      const bugsnagClient = getBugsnagClient()
      const ErrorBoundary = bugsnagClient.getPlugin('react')

      return (
        <ErrorBoundary FallbackComponent={ErrorPage}>
          <App {...this.props} />
        </ErrorBoundary>
      )
    }
  }
}

export default withBugsnagClient
